import { Controller } from '@hotwired/stimulus';

import Helper from '@/modules/helper';

export default class extends Controller {
  connect() {
    const $el = $(this.element);

    $el.maskMoney({
      allowZero: true,
      decimal: ',',
      prefix: `${Helper.currencySymbol()} `,
      thousands: '.',
    });
  }
}
